///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../filter-templates/purchase-orders.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="report-distributor.ts"/>
///<reference path="../collections/report-purchase-orders.collection.ts"/>
///<reference path="../collection-population-strategies/purchase-order-to-distributor.strategy.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;


    export class ReportDistributorPurchaseOrder extends ReportDistributorDataTemplate implements IDataTemplate {

        protected purchaseOrders: ReportPurchaseOrdersCollection;

        get totalSelectedCount() {
            return this.purchaseOrders.selectedModelsLength;
        }

        // get collection(): SmartMoverCollectionBase<any> {
        //     return this.purchaseOrders;
        // }

        constructor(model: Dictionary<any>, properties: string[], {criteria, defaultValue}: IDataTemplateOptions) {
            super(model, properties, {criteria, defaultValue});

            this.purchaseOrders = new ReportPurchaseOrdersCollection(this.model[properties[1]], [], {
                criteria,
                displayNameKey: 'purchaseOrderNumber',
                idKey: 'purchaseOrderId',
                defaultValue: defaultValue[properties[1]],
            });

            this.purchaseOrders.setParentCollection(this.distributors, PurchaseOrderToDistributorStrategy);

            this.filters = [new PurchaseOrdersReceivedItemsFilter([this.purchaseOrders])];
            this.title = 'HERO_SUB_PURCHASE_ORDERS';
            this.allSelectedLabel = 'LABEL_ALL_PURCHASE_ORDERS';
            this.totalSelectedMessage = 'LABEL_PURCHASE_ORDERS_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.purchaseOrders.setWatchers(scope);
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: ng.IQService): ng.IPromise<any> {
            this.purchaseOrders.updateCriteria(newCriteria);

            return this.purchaseOrders.fetch();
        }
    }
}
